/**
 * Централизованные форматтеры для логов: длительность и время вызова.
 */

const LOCALE = 'ru-RU'
const INVOKED_AT_OPTS = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' }

/**
 * Форматирует длительность из миллисекунд (1 знак после запятой).
 * @param {number | null | undefined} ms
 * @param {string} [lang='ru'] - 'ru' для "с", 'en' для "s"
 * @returns {string | null} "5.3 с" или "5.3 s"
 */
export function formatDurationMs(ms, lang = 'ru') {
  if (ms == null || ms < 0) return null
  const secSuffix = lang === 'en' ? 's' : 'с'
  const minSuffix = lang === 'en' ? 'm' : 'м'
  const sec = ms / 1000
  const secStr = sec % 1 === 0 ? String(Math.round(sec)) : sec.toFixed(1)
  if (sec < 60) return `${secStr} ${secSuffix}`
  const m = Math.floor(sec / 60)
  const s = sec % 60
  const sStr = s % 1 === 0 ? String(Math.round(s)) : s.toFixed(1)
  return `${m} ${minSuffix} ${sStr} ${secSuffix}`
}

/**
 * Форматирует длительность из двух временных меток (ISO строки или Date).
 * @param {string | Date | null | undefined} startAt
 * @param {string | Date | null | undefined} endAt
 * @param {string} [lang='ru']
 * @returns {string | null}
 */
export function formatDurationFromTimestamps(startAt, endAt, lang = 'ru') {
  if (!startAt || !endAt) return null
  const start = new Date(startAt).getTime()
  const end = new Date(endAt).getTime()
  const ms = end - start
  if (ms < 0) return null
  return formatDurationMs(ms, lang)
}

/**
 * Форматирует время вызова (дата и время в формате как у родительского лога).
 * @param {string | Date | null | undefined} isoOrDate
 * @returns {string | null} "12 мар, 14:30:45"
 */
export function formatInvokedAt(isoOrDate) {
  if (!isoOrDate) return null
  return new Date(isoOrDate).toLocaleString(LOCALE, INVOKED_AT_OPTS)
}
